import React from "react";
import { Link } from "react-router-dom";
import { LegalPage, Sec, Ul, COMPANY } from "@/components/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" testid="terms-page">
      <p>These Terms of Service (“Terms”) govern your use of Hat Trick (hat-trick.cc), including the Hat Trick NHL, First Bucket NBA and Green Ball tennis dashboards (the “Service”), operated by {COMPANY} (“we”, “us”). By creating an account or using the Service, you agree to these Terms. If you do not agree, do not use the Service.</p>

      <Sec n={1} title="Eligibility">
        <p>You must have reached the legal age for sports wagering in the place where you live (for example, 21 in most U.S. states, and 18 or 19 in Canada depending on the province) to use the Service. You are responsible for complying with all laws that apply to you, including any laws on sports wagering where you are located.</p>
      </Sec>

      <Sec n={2} title="Your account">
        <Ul items={[
          "Provide accurate information and keep your password confidential.",
          "You are responsible for activity under your account. Tell us promptly if you suspect unauthorised use.",
          "One person per account. Do not share, sell or transfer your account.",
        ]} />
      </Sec>

      <Sec n={3} title="Informational service only — no betting advice">
        <p>Hat Trick provides sports statistics, research tools, model scores, rankings and statuses (such as APPROVED, VALUE or WATCH) for informational and entertainment purposes only.</p>
        <Ul items={[
          "Nothing in the Service is financial, investment or betting advice, or a recommendation to place any wager.",
          "Model outputs are estimates based on historical and public data. They can be wrong, incomplete or delayed, and past performance shown in any audit or backtest does not predict future results.",
          "We do not accept wagers, act as a sportsbook, or hold or transfer money on your behalf.",
          "Any decision you make, including any wager, is made at your own risk and is your sole responsibility.",
        ]} />
        <p>If you choose to gamble, please do so responsibly. If gambling is a problem for you or someone you know, call 1-800-GAMBLER (U.S.) or contact your provincial problem-gambling helpline (Canada).</p>
      </Sec>

      <Sec n={4} title="Free access and future paid plans">
        <p>The Service is currently free. We may introduce paid features (such as Hat Trick Premium) in the future. No paid plan is on sale today, and you will never be charged without first agreeing to clear pricing and additional terms.</p>
      </Sec>

      <Sec n={5} title="Acceptable use">
        <p>You agree not to:</p>
        <Ul items={[
          "Scrape, copy, resell or redistribute the Service or its data, or use it to build a competing product.",
          "Interfere with, overload, reverse-engineer or try to bypass the security or access controls of the Service.",
          "Use the Service for any unlawful purpose, including where sports wagering is prohibited.",
          "Impersonate others or create accounts by automated means.",
        ]} />
      </Sec>

      <Sec n={6} title="Third-party data and services">
        <p>The Service displays statistics, schedules, lineups and odds from public third-party sources and uses third-party services (such as sign-in and AI providers). We do not control and are not responsible for third-party content, its accuracy or availability. Team and league names and marks belong to their respective owners; Hat Trick is not affiliated with or endorsed by any league, team or sportsbook.</p>
      </Sec>

      <Sec n={7} title="Intellectual property">
        <p>The Service, including its software, models, design, text and the Hat Trick, First Bucket and Green Ball names and logos, belongs to {COMPANY} or its licensors. We grant you a limited, personal, non-exclusive, non-transferable licence to use the Service for your own non-commercial use while these Terms are in effect.</p>
      </Sec>

      <Sec n={8} title="Privacy">
        <p>Our <Link to="/privacy" className="text-[#22D3EE] hover:text-white">Privacy Policy</Link> explains how we collect and use personal information.</p>
      </Sec>

      <Sec n={9} title="Suspension and termination">
        <p>You may stop using the Service at any time and ask us to delete your account. We may suspend or end your access if you breach these Terms, if required by law, or if we discontinue the Service.</p>
      </Sec>

      <Sec n={10} title="Disclaimers">
        <p>The Service is provided “as is” and “as available”, without warranties of any kind, express or implied, including accuracy, fitness for a particular purpose, uninterrupted availability or non-infringement, to the fullest extent permitted by law.</p>
      </Sec>

      <Sec n={11} title="Limitation of liability">
        <p>To the fullest extent permitted by law, {COMPANY} and its owners, employees and partners will not be liable for any indirect, incidental, special, consequential or punitive damages, or for any loss of profits, wagers, data or goodwill, arising from your use of the Service. Our total liability for any claim relating to the Service is limited to the amount you paid us in the 12 months before the claim (currently $0) or USD $100, whichever is greater. Some jurisdictions do not allow certain limitations, so some of these may not apply to you.</p>
      </Sec>

      <Sec n={12} title="Indemnity">
        <p>You agree to indemnify and hold {COMPANY} harmless from claims arising from your misuse of the Service or your breach of these Terms.</p>
      </Sec>

      <Sec n={13} title="Governing law">
        <p>If you live in the United States, these Terms are governed by applicable U.S. federal law and the laws of the state in which {COMPANY} is organised. If you live in Canada, these Terms are governed by the laws of your province or territory of residence and the federal laws of Canada that apply there. Nothing in these Terms limits any consumer-protection rights you have under the law where you live.</p>
      </Sec>

      <Sec n={14} title="Changes to these Terms">
        <p>We may update these Terms. We will change the effective date above and, for material changes, give notice in the app. Continuing to use the Service after changes take effect means you accept them.</p>
      </Sec>

      <Sec n={15} title="Contact">
        <p>Questions about these Terms can be sent to {COMPANY} through the Hat Trick app while signed in, or through the contact channel listed on hat-trick.cc.</p>
      </Sec>
    </LegalPage>
  );
}
